import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { sendChessMessage, subscribeChessChat } from "../services/chessChat";

const MAX_MESSAGE = 200;

const ChessChat = ({ gameId, userId, displayName }) => {
  const { t } = useLanguage();
  const [messages, setMessages] = useState([]);
  const [draft, setDraft] = useState("");
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => subscribeChessChat(gameId, setMessages), [gameId]);

  useEffect(() => {
    endRef.current?.scrollIntoView({ block: "nearest" });
  }, [messages]);

  const send = async () => {
    const text = draft.trim();
    if (!text || sending) return;
    setSending(true);
    setDraft("");
    try {
      await sendChessMessage(gameId, { userId, displayName, text });
    } catch {
      setDraft(text);
    } finally {
      setSending(false);
      inputRef.current?.focus();
    }
  };

  return (
    <section className="chess-chat" aria-label={t("chessChat")}>
      <h2 className="chess-chat-title">{t("chessChat")}</h2>
      <div className="chess-chat-log">
        {messages.length === 0 && <p className="chess-chat-empty">{t("chessChatEmpty")}</p>}
        {messages.map((message) => {
          const mine = message.userId === userId;
          return (
            <div
              key={message.id}
              className={`chess-bubble ${mine ? "is-mine" : "is-theirs"}`}
            >
              {!mine && <span className="chess-bubble-name">{message.displayName}</span>}
              <p>{message.text}</p>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>
      <form
        className="chess-chat-compose"
        onSubmit={(event) => {
          event.preventDefault();
          send();
        }}
      >
        <input
          ref={inputRef}
          type="text"
          className="chess-chat-input"
          value={draft}
          maxLength={MAX_MESSAGE}
          placeholder={t("chessChatPlaceholder")}
          aria-label={t("chessChatPlaceholder")}
          disabled={sending}
          onChange={(event) => setDraft(event.target.value.slice(0, MAX_MESSAGE))}
        />
        <button type="submit" className="chess-chat-send" disabled={!draft.trim() || sending}>
          {t("chessChatSend")}
        </button>
      </form>
    </section>
  );
};

export default ChessChat;
